const routes = {
    path: 'interlocutores',
    name: 'MapaParceiros_Interlocutor',
    component: () => import('./lista/ListaInterlocutores.vue'),
    meta: {
        rules: ['MAPAPARC-PES-00'],
    },
};

export default routes;